import React from "react";

function About() {
  return (
    <div>
      <h1>About ShopNest</h1>
      <p>This is the About Page</p>
    </div>
  );
}

export default About;
